export default __webpack_public_path__ + "static/media/cold-cup.a7545b88.webp";